<template>
	<div>
		<div class="instruction pb-2">If {{ item.name }} runs, map this data to the parameter:</div>
		<div class="parameter-branch-mapping">
			<ParamsFormInputField
				:param="{ name: 'map', description: 'value', key: item.id, type: 'string' }"
				@update-input-field="updateInputField"
				@update-input-field-label="updateInputFieldLabel"
				:initValues="{ value: value, valueLabel: valueLabel }"
				:multipleSelection="!isSingleSelection"
				:node="editNode"
				:branchID="item.id"
				:valuesTypes="valuesTypes"
				:readonly="!hasEditPermissions"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ParamsFormInputField from '@/components/BlockEditor/BlockEditorParams/ParamsFormInputField';
import DataInputMenuService from '@/components/DataInput/DataInputMenu/data-input-menu-service';
import { TABLE_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';
import isEqual from 'lodash/isEqual';

export default {
	name: 'ParameterBranchMapping',
	props: {
		item: { type: Object },
		isSingleSelection: { type: Boolean },
		hasEditPermissions: { type: Boolean },
		value: { type: [String, Number, Object] },
		valueLabel: { type: [String, Number, Object] },
		valuesTypes: { type: Array, validator: DataInputMenuService.valueTypesValidator, default: () => [] },
	},
	components: {
		ParamsFormInputField,
	},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		localValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('updateValue', value);
			},
		},
		localValueLabel: {
			get() {
				return this.valueLabel;
			},
			set(value) {
				this.$emit('updateValueLabel', value);
			},
		},
		branchId() {
			return this.item.id;
		},
		inputIsReadonly() {
			return isEqual(this.valuesTypes, TABLE_ONLY_ALLOWED_VALUE_TYPES);
		},
	},
	methods: {
		updateInputField(payload) {
			const { map, label } = payload;
			const { value } = map;
			this.localValue = value;
			// TODO - make sure we dont need this anymore,
			// as this is not used and updateInputfieldLabel is being called directly when needed
			if (label) {
				this.updateInputFieldLabel({ label });
			}
		},
		updateInputFieldLabel(payload) {
			const { label } = payload;
			const { value } = label;
			this.localValueLabel = value;
		},
	},
};
</script>

<style lang="scss" scoped>
.instruction {
	font-size: 14px;
	color: #707c8a;
}
// this is a series of hacks bassically since we only override  BlockEditorParamsFormInputField  styles
.parameter-branch-mapping {
	::v-deep {
		.v-input {
			font-size: 12px;
		}
		.input-label {
			display: none;
		}

		.v-select {
			margin: 0 0 16px 0;
			padding: 0;
			border: 1px solid #dfe4ef;
			border-radius: 4px;

			.v-select__selection {
				margin: 7px 15px -7px 15px;
			}
			.v-input__slot {
				margin: 0;

				&::before,
				&::after,
				.v-input__icon {
					display: none;
				}
				input {
					padding: 5px 0;
				}
			}
		}

		.insert-data-container {
			width: 500px !important;
		}
	}
}
</style>
